module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-319.a1cc691.woff2";